import { ProfileResource } from "@medplum/core";

import { NOTIFICATION_PREFERENCES } from "../types/NotificationsPreference";

import { hasOptedInToNotification } from "./checkNotificationPreference";

/**
 * Returns the notification preference ids a profile is opted in to.
 *
 * @param profile - The profile resource to read preferences from.
 * @returns The opted-in preference ids, in `NOTIFICATION_PREFERENCES` order.
 */
export const getSelectedNotificationPreferenceIds = (profile: ProfileResource): string[] =>
  NOTIFICATION_PREFERENCES.reduce<string[]>((selectedIds, preference) => {
    if (hasOptedInToNotification(profile, preference.id)) selectedIds.push(preference.id);
    return selectedIds;
  }, []);
